import { createApp } from 'vue'
import Cookies from 'js-cookie'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import locale from 'element-plus/es/locale/lang/zh-cn'

import '@/assets/styles/index.scss'
import App from './App.vue'
import store from './store'
import router from './router'
import directive from './directive'
import plugins from './plugins'

import 'virtual:svg-icons-register'
import SvgIcon from '@/components/SvgIcon/index.vue'
import elementIcons from '@/components/SvgIcon/svgicon'

import './permission'
import './utils/clientReceiver'

if (import.meta.env.VITE_APP_ENV === 'test') {
  void import('eruda').then(({ default: eruda }) => {
    eruda.init()
  })
}

const app = createApp(App)

app.use(router)
app.use(store)
app.use(plugins)
app.use(elementIcons)
app.component('svg-icon', SvgIcon)

directive(app)

app.use(ElementPlus, {
  locale,
  size: Cookies.get('size') || 'default',
})

app.mount('#app')
